import React, { lazy } from 'react';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart, CART_URL } from '../lib/metaPixel';
export function TestimonialsSection() {
  const transformationImage = 'https://cdn.magicpatterns.com/uploads/7adVhdzgNgnbvJJSuA4jek/ChatGPT_Image_18_may_2026,_11_55_05.png';
  const testimonials = [{
    name: 'Javier Pérez',
    text: 'Bajé 9 kilos en 3 meses. Tener el paso a paso tan claro me ayudó muchísimo a no abandonar.',
    image: transformationImage,
    beforeAfter: transformationImage
  }, {
    name: 'Joaquín Ferreira',
    text: 'Me saque 6kg extra que tenia de grasa!! El sistema es muy fácil de seguir. Pensé que iba a ser complicado, pero está todo explicado de forma simple.',
    image: 'https://cdn.magicpatterns.com/uploads/1h29s5LGZxRuzWBnLZHmtN/ChatGPT_Image_18_may_2026,_11_54_34.png',
    beforeAfter: 'https://cdn.magicpatterns.com/uploads/1h29s5LGZxRuzWBnLZHmtN/ChatGPT_Image_18_may_2026,_11_54_34.png'
  }, {
    name: 'Federico Silva',
    text: 'Lo que más me sirvió fue entender qué comer y cómo organizarme. Antes improvisaba todo, ahora con 10kg menos puedo jugar con mis hijos sin agitarme.',
    image: 'https://cdn.magicpatterns.com/uploads/vZftq55mH8cZVFu9JexSrK/ChatGPT_Image_18_may_2026,_11_55_24.png',
    beforeAfter: 'https://cdn.magicpatterns.com/uploads/vZftq55mH8cZVFu9JexSrK/ChatGPT_Image_18_may_2026,_11_55_24.png'
  }, {
    name: 'Lucas Méndez',
    text: 'En 12 semanas perdí la panza que arrastraba hace años. Lo mejor fue no sentirme a dieta en ningún momento y haber bajado 8 kilos.',
    image: 'https://cdn.magicpatterns.com/uploads/t2f5vaigHWkmxgRbWAnPVB/ChatGPT_Image_18_may_2026,_11_55_51.png',
    beforeAfter: 'https://cdn.magicpatterns.com/uploads/t2f5vaigHWkmxgRbWAnPVB/ChatGPT_Image_18_may_2026,_11_55_51.png'
  }];
  return <section className="py-14 md:py-20 bg-zinc-900 pt-[20px] pb-[20px]" data-id="element-348">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-349">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-6xl mx-auto" data-id="element-350">
          <div className="text-center mt-[15px] mb-[15px]" data-id="element-351">
            <div className="flex items-center justify-center gap-1 mb-6" data-id="element-352">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" data-id="element-353" />)}
            </div>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white mb-6 uppercase tracking-tight leading-[0.95]" data-id="element-354">
              Personas ya empezaron a aplicar
            </h2>
            <div className="inline-block bg-orange-500/10 border border-orange-500/30 px-6 py-2 rounded-full" data-id="element-355">
              <p className="text-xl text-orange-500 font-bold uppercase tracking-widest" data-id="element-356">
                Más de 500 descargas
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-10" data-id="element-357">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} className={`bg-black border border-zinc-800 rounded-3xl p-8 md:p-10 hover:border-zinc-600 transition-colors ${testimonial.beforeAfter ? 'md:col-span-2' : ''}`} data-id="element-358">
                {testimonial.beforeAfter && <div className="mb-8 rounded-2xl overflow-hidden border border-zinc-800 max-w-2xl mx-auto" style={{
              aspectRatio: '4 / 5'
            }} data-id="element-359">
                    <img src={testimonial.beforeAfter} alt={`Transformación de ${testimonial.name}`} width={800} height={1000} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-360" />
                  </div>}
                <div className="flex items-center gap-1 mb-6" data-id="element-361">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-362" />)}
                </div>
                <p className="text-zinc-300 leading-relaxed mb-8 text-lg md:text-xl italic" data-id="element-363">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-4" data-id="element-364">
                  <img src={testimonial.image} alt={testimonial.name} width={56} height={56} loading="lazy" decoding="async" className="w-14 h-14 rounded-full object-cover border-2 border-zinc-800" data-id="element-365" />
                  <span className="text-white font-bold text-lg" data-id="element-366">
                    — {testimonial.name}
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-367">
            <a href={CART_URL} onClick={() => trackAddToCart({
            value: 329,
            currency: 'USD',
            content_name: 'Plan Anti Panza'
          })} className="flex items-center justify-center w-full md:w-auto md:inline-flex bg-orange-500 hover:bg-orange-400 text-white font-black text-xl md:text-2xl px-12 py-6 rounded-xl uppercase tracking-wide transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_40px_rgba(249,115,22,0.4)]" data-id="element-368">
              Acceder ahora con 50% off por $329
            </a>
            <div className="flex items-center justify-center flex-wrap mt-4 text-sm text-zinc-400 font-medium gap-[1px]" data-id="element-369">
              <span className="flex items-center text-[10px] gap-[1px]" data-id="element-370">
                <ShieldCheckIcon className="w-4 h-4 text-green-500" data-id="element-371" /> Pago 100%
                seguro
              </span>
              <span className="pl-[2px] pr-[2px]" data-id="element-372"> · </span>
              <span className="text-[10px]" data-id="element-373">Acceso de por vida</span>
              <span className="pl-[2px] pr-[2px]" data-id="element-374">·</span>
              <span className="text-[10px]" data-id="element-375">
                Pago único{' '}
                <strong className="font-[500] text-[#A1A1AA]" data-id="element-376">$329</strong>
              </span>
            </div>
            <div className="flex items-center justify-center flex-wrap gap-2 mt-3" data-id="element-377">
              <span className="bg-zinc-800/50 border border-zinc-700 px-3 py-1 rounded-md text-[10px] font-bold text-zinc-400 tracking-wider" data-id="element-378">
                VISA
              </span>
              <span className="bg-zinc-800/50 border border-zinc-700 px-3 py-1 rounded-md text-[10px] font-bold text-zinc-400 tracking-wider" data-id="element-379">
                MASTERCARD
              </span>
              <span className="bg-zinc-800/50 border border-zinc-700 px-3 py-1 rounded-md text-[10px] font-bold text-zinc-400 tracking-wider" data-id="element-380">
                AMEX
              </span>
              <span className="bg-[#009EE3]/10 border border-[#009EE3]/40 px-3 py-1 rounded-md text-[10px] font-bold text-[#00B1EA] tracking-wider flex items-center gap-1" data-id="element-381">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#00B1EA]" data-id="element-382" />
                MERCADO PAGO
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}